import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

const useUsers = () => {
    const [userList, setUserList] = useState([]);

    const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/bms/users`;
    const { data: users, isLoading, refetch } = useQuery('users', () => fetch(url)
        .then(res => res.json()));


    useEffect(() => {
        if (users) {
            setUserList(users?.data);
        }
    }, [users]);

    return { userList, isLoading, refetch }
};

export default useUsers;